export default __webpack_public_path__ + "static/fitness_back-9da7870e6f7f4deaa736a64fcf95b60e.webp";